import { computed } from 'mobx'
import { type IValidationSchema, validationContext } from 'validx'
import type { LegendPartDependencies } from '@/features/legends/editor/legend-part-dependencies'
import { LegendPartViewModelBase } from '@/features/legends/editor/LegendPartViewModelBase'
import {
  addGenericErrorForProperty,
  type ErrorDescriptor,
} from '@/features/legends/editor/analyzer-errors'
import { validateObject } from '@/utils/validx-util'
import { InfoLinesBuilderViewModel } from './InfoLinesBuilderViewModel'
import type { InfoLine } from './legend-options'

/**
 * The legend's Info options. A builder, so info line formulas see the
 * questions.
 */
export class InfoOptionsViewModel extends LegendPartViewModelBase {
  private readonly _schema: IValidationSchema<InfoOptionsViewModel> = {
    infoLines: [validateObject('There are invalid lines.')],
  }

  readonly infoLines: InfoLinesBuilderViewModel

  readonly validation = validationContext(this, this._schema)

  constructor(dependencies: LegendPartDependencies) {
    super(dependencies)
    this.infoLines = new InfoLinesBuilderViewModel(dependencies, this)
    this.lifecycle.manage(this.infoLines)
  }

  @computed
  private get _json(): InfoLine[] {
    return this.infoLines.toJSON()
  }

  /**
   * Sets the info lines from the legend document.
   */
  hydrate(infoLines: InfoLine[] | undefined) {
    this.infoLines.hydrate(infoLines ?? [])
  }

  /**
   * Shows the analyzer's errors on the info lines.
   */
  receiveErrors(descriptor: ErrorDescriptor | null | undefined) {
    addGenericErrorForProperty(
      this,
      descriptor,
      'infoLines',
      'There are invalid info lines',
    )
    this.infoLines.receiveErrors(descriptor)
  }

  /**
   * The info lines as the legend document has them.
   */
  toJSON() {
    return this._json
  }
}
